module.exports = __webpack_public_path__ + "img/logo-name.a0183d05.png";